import React, { useState, useEffect, useRef } from "react";
import "./Header.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login, logout } from "../actions/authActions";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo, error } = userLogin;

  const prevUserInfoRef = useRef();
  useEffect(() => {
    if (userInfo !== prevUserInfoRef.current) {
      prevUserInfoRef.current = userInfo;
      if (userInfo) {
        if (userInfo.user.role === "admin") {
          navigate("/admin-dashboard");
        } else {
          navigate("/home");
        }
      }
    }
  }, [userInfo, navigate]);

  const handlePayClick = () => {
    if (!userInfo) {
      alert("Please login to access the payment portal.");
    } else {
      alert("Redirecting to payment portal...");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(login(email, password));
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const navigateHome = () => {
    if (userInfo) {
      if (userInfo.user.role === "admin") {
        navigate("/admin-dashboard");
      } else {
        navigate("/home");
      }
    } else {
      navigate("/");
    }
  };

  return (
    <header>
      <div className="header-left">
        <img
          src="/REDRONES_LOGO2.png"
          alt="REDrones Logo"
          onClick={navigateHome}
          style={{ cursor: "pointer", height: "auto", width: "150px" }}
        />
      </div>
      <div className="header-center">
        <button onClick={() => navigate("/contact")}>Contact Us</button>
        <button onClick={handlePayClick}>Pay Invoice Online</button>
      </div>
      <div className="header-right">
        {userInfo ? (
          <button className="logout-button" onClick={handleLogout}>
            Logout
          </button>
        ) : (
          <form
            onSubmit={handleSubmit}
            style={{ display: "inline-block", margin: 0 }}
          >
            {/* First row: Email, Password, Login */}
            <div
              style={{
                display: "inline-flex",
                gap: "5px",
                alignItems: "center",
              }}
            >
              <input
                type="text"
                placeholder="Email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <input
                type="password"
                placeholder="Password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button type="submit">Login</button>
            </div>

            {/* Second row: Forgot Password? link */}
            <div
              style={{
                textAlign: "right",
                marginTop: "2px",
                fontSize: "0.85rem",
              }}
            >
              <span
                onClick={() => navigate("/forgot-password")}
                style={{
                  color: "#00f",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                Forgot Password?
              </span>
            </div>
          </form>
        )}
        {error && !userInfo && (
          <div style={{ color: "red", marginTop: "5px" }}>{error}</div>
        )}
      </div>
    </header>
  );
};

export default Header;
